import { Notification } from 'element-ui';
import store from '@/store';

export const emailCampaignFeatureGuard = async (to, from, next) => {
  try {
    // check to see if company has access to feature, if so continue, else redirect to block page
    await store.dispatch('emailCampaign/getCompanySettings');
    if (
      store.getters['emailCampaign/campaignsFeatureIsSetup']
      && store.getters['emailCampaign/campaignsFeatureIsActive']
    ) {
      next();
    } else {
      next({
        name: 'Email campaigns / Setup',
      });
    }
  } catch (error) {
    Notification({
      type: 'error',
      title: 'Error',
      message: 'Error loading email campaign feature.',
    });
  }
};

export const emailCampaignBlockPageGuard = async (to, from, next) => {
  try {
    // check to see if company has access to feature, if so redirect to feature, else continue
    await store.dispatch('emailCampaign/getCompanySettings');
    if (
      store.getters['emailCampaign/campaignsFeatureIsSetup']
      && store.getters['emailCampaign/campaignsFeatureIsActive']
    ) {
      next({
        name: 'Email campaigns',
      });
    } else {
      next();
    }
  } catch (error) {
    Notification({
      type: 'error',
      title: 'Error',
      message: 'Error loading email campaign feature.',
    });
  }
};
